<template>
  <v-app>
    <v-layout row wrap class>
      <!-- <v-flex xs12>
        <div class="mymenu">
          <router-link to="/">
            <div class="logo">
              <img src="/static/logo-small.png" alt="Brannvernskolen">
            </div>
          </router-link>
          <div class="links">
            <router-link to="/laerer">
              <button class="mymenu_link">Lærere</button>
            </router-link>
            <router-link to="/instruktor">
              <button class="mymenu_link">Instruktører</button>
            </router-link>
            <router-link to="/spill">
              <button class="mymenu_link">Spill</button>
            </router-link>
            <router-link to="/registrer">
              <button class="mymenu_link">Registrer</button>
            </router-link>
            <router-link to="/resultater">
              <button class="mymenu_link">Resultater</button>
            </router-link>
          </div>
        </div>
      </v-flex>-->
      <v-flex xs12 text-xs-center>
        <transition name="slide-y-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-flex>
      <v-flex xs12 text-xs-center class="app-footer">
        <router-link to="/terms">
          <button class="mymenu_link">Om Brannvernskolen</button>
        </router-link>
        <div class="luft"></div>
        <div v-html="footer"></div>
        <div class="luft"></div>
      </v-flex>
    </v-layout>
    <!-- <v-container fluid></v-container> -->
  </v-app>
</template>

<script>
import axios from 'axios'

let apiURL = '';

if(process.env.NODE_ENV == 'development') {
  apiURL = 'https://brannvernskolen-website.ddev.site';
} 

export default {
  data () {
    return {
      playBtn: 'Spill og lær',
      teacherBtn: 'Jeg er lærer',
      instructorBtn: 'Jeg er instrøktør',
      footer: ''
    }
  },
  created: function () {
    axios
      .get(apiURL + '/api/getFooter')
      .then(response => {
        this.footer = response.data.data[0].content
      })
      .catch(error => {
        console.log(error)
      })
  }

}
</script>

<style>
@import "/assets/custom.css";
</style>



// WEBPACK FOOTER //
// src/App.vue